module.exports = __webpack_public_path__ + "36dadebb0a715ede6717afdb2fb05a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/jianjie/jianjie-title.png
// module id = 1224
// module chunks = 0